var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"nav-footer"},[_c('ul',{staticClass:"nav"},_vm._l((_vm.footerItems),function(ref,i){
var title = ref.title;
var route = ref.route;
return _c('li',{key:route,staticClass:"nav-item"},[_c('a',{staticClass:"item-link",attrs:{"href":_vm.buildURL(route),"target":"_blank"}},[_vm._v(_vm._s(title))]),(i !== _vm.footerItems.length-1)?_c('i',{staticClass:"dots"},[_vm._v("·")]):_vm._e()])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da596b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout-components/TheFooter.vue
// module id = null
// module chunks = 